/** @jsx jsx */
import { jsx } from "theme-ui"

import { vwoService } from "@trueskin-web/services"

import arrowShortRightSvg from "./arrowShortRightIcon.svg"

export const arrowShortRightIcon = vwoService.isThemeRebrandedEnabled()
  ? arrowShortRightSvg
  : {
      path: (
        <path
          d="M 15.0391 1 L 20.7931 7 L 15.0391 13 M 20.8 7 H 9"
          stroke="currentColor"
        />
      ),
      viewBox: "4 0 21 14",
      fill: "none",
    }
